export const STARTER_KIT_BASE_URL =
  "https://edify-resources.s3.sa-east-1.amazonaws.com"

export const STARTER_KIT_SOURCE_LABEL = "Pixabay"

export interface StarterKitImage {
  id: string
  path: string
  label?: string
}

export const STARTER_KIT_IMAGES: StarterKitImage[] = [
  { id: "sk-1", path: "starter-kit/construction-1.jpg", label: "Obra en construcción" },
  { id: "sk-2", path: "starter-kit/construction-2.jpg", label: "Herramientas" },
  { id: "sk-3", path: "starter-kit/construction-3.jpg", label: "Edificio" },
  { id: "sk-4", path: "starter-kit/construction-4.jpg", label: "Trabajador" },
  { id: "sk-5", path: "starter-kit/construction-5.jpg", label: "Casa" },
  { id: "sk-6", path: "starter-kit/construction-6.jpg", label: "Maquinaria" },
  { id: "sk-7", path: "starter-kit/construction-7.jpg", label: "Reforma" },
  { id: "sk-8", path: "starter-kit/construction-8.jpg", label: "Electricidad" },
  { id: "sk-9", path: "starter-kit/construction-9.jpg", label: "Plomería" },
  { id: "sk-10", path: "starter-kit/construction-10.jpg", label: "Pintura" },
  { id: "sk-11", path: "starter-kit/construction-11.jpg", label: "Carpintería" },
  { id: "sk-12", path: "starter-kit/construction-12.jpg", label: "Jardín" },
  { id: "sk-13", path: "starter-kit/construction-13.jpg", label: "Fachada" },
  { id: "sk-14", path: "starter-kit/construction-14.jpg", label: "Interior" },
  { id: "sk-15", path: "starter-kit/construction-15.jpg", label: "Obra gruesa" },
  { id: "sk-16", path: "starter-kit/construction-16.jpg", label: "Andamio" },
  { id: "sk-17", path: "starter-kit/construction-17.jpg", label: "Techos" },
  { id: "sk-18", path: "starter-kit/construction-18.jpg", label: "Hogar" },
  { id: "sk-19", path: "starter-kit/construction-19.jpg", label: "Oficina" },
  { id: "sk-20", path: "starter-kit/construction-20.jpg", label: "Comercial" },
]

export function getStarterKitImageUrl(item: StarterKitImage): string {
  const base = STARTER_KIT_BASE_URL.replace(/\/$/, "")
  const path = item.path.startsWith("/") ? item.path.slice(1) : item.path
  return `${base}/${path}`
}
